import script from "./HlsVideoPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./HlsVideoPlayer.vue?vue&type=script&setup=true&lang=js"

import "./HlsVideoPlayer.vue?vue&type=style&index=0&id=6513b0e6&scoped=true&lang=css"

import exportComponent from "/root/buildarea/v8-development-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6513b0e6"]])

export default __exports__